import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/")) {
      // silently ignore; AuthContext handles redirect
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const HUB_META = {
  aerospace: { color: "#00E5FF", short: "AER" },
  automotive: { color: "#E60012", short: "AUT" },
  ev: { color: "#00E676", short: "EV" },
  uam: { color: "#FFAB00", short: "UAM" },
  logistics: { color: "#A78BFA", short: "LOG" },
  stories: { color: "#FFFFFF", short: "PUB" },
  space: { color: "#E60012", short: "SPC" },
  policy: { color: "#FCD34D", short: "POL" },
  sustainability: { color: "#34D399", short: "SUS" },
  ai: { color: "#22D3EE", short: "AI" },
};

export function formatRelative(iso) {
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
  return d.toLocaleDateString();
}
